import { Button, makeStyles, mergeClasses, Spinner } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IFilterActionBarProps {
    primaryHandler: (event: React.MouseEvent<HTMLElement>) => void;
    primaryButtonLabel: string;
    primaryButtonId?: string;
    primaryButtonDisabled?: boolean;
    primaryButtonProcessing?: boolean;
    primaryButtonProcessingLabel?: string;
    secondaryHandler: (event: React.MouseEvent<HTMLElement>) => void;
    secondaryButtonLabel: string;
    secondaryButtonDisabled?: boolean;
    secondaryButtonDisplayed?: boolean;
    wrapperStyles?: string;
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '10px',
    },
    defaultPadding: {
        paddingTop: '16px',
        paddingRight: '20px',
        paddingBottom: '16px',
        paddingLeft: '20px',
    },
});

const FilterActionBar: React.FC<IFilterActionBarProps> = (props: IFilterActionBarProps) => {
    const { t } = useTranslation();
    const styles = useStyles();
    const isProcessing = props.primaryButtonProcessing ?? false;
    const primaryLabel = t(props.primaryButtonLabel);
    const processingLabel = props.primaryButtonProcessingLabel ? t(props.primaryButtonProcessingLabel) : t('processing').toString();

    return (
        <div className={mergeClasses(styles.root, props.wrapperStyles ?? styles.defaultPadding)}>
            <Button
                appearance='primary'
                aria-label={t(props.primaryButtonLabel)}
                onClick={props.primaryHandler}
                disabled={Boolean((props.primaryButtonDisabled ?? false) || isProcessing)}
                id={props.primaryButtonId}
            >
                {isProcessing ? processingLabel : primaryLabel}
                {isProcessing && <Spinner size='extra-tiny' />}
            </Button>
            {props.secondaryButtonDisplayed !== false && (
                <Button
                    appearance='secondary'
                    aria-label={t(props.secondaryButtonLabel).toString()}
                    onClick={props.secondaryHandler}
                    disabled={props.secondaryButtonDisabled}
                >
                    {t(props.secondaryButtonLabel).toString()}
                </Button>
            )}
        </div>
    );
};

export default FilterActionBar;
